import {
  paymentFailureFromError,
  PaymentFailureMetadata,
  readPaymentFailure,
} from './paymentFailure';

const CANCELLATIONS = new Set(['USER_CANCEL', 'PAY_PROCESS_CANCELED', 'C0998']);
export function isPaymentCancellation(value: unknown): boolean {
  const e = (
    value !== null && typeof value === 'object' ? value : {}
  ) as Record<string, unknown>;
  const metadata = paymentFailureFromError(value);
  return [e.code, e.pg_error_code, e.statusKey, metadata.pg_error_code].some(
    code => typeof code === 'string' && CANCELLATIONS.has(code),
  );
}
/** 노출 이벤트 payload. 보내지 않는 경우(필수값 누락·사용자 취소·space 흐름인데 space_id 없음)는 null. */
export function toFailureImpression(
  value: unknown,
): PaymentFailureMetadata | null {
  const metadata = readPaymentFailure(value);
  const { payment_flow, pg_provider } = metadata;
  if (!payment_flow || !pg_provider || isPaymentCancellation(metadata))
    return null;
  // business 결제는 space 와 무관하다. 그 외 흐름은 숫자 space_id 가 있어야 한다.
  if (payment_flow !== 'business_payment' && metadata.space_id === undefined)
    return null;
  return { ...metadata, payment_flow, pg_provider };
}
